import { Link, styled } from '@mui/material';

export const StyledLink = styled(Link)(({ theme }) => ({
  color: 'inherit',
  fontSize: '0.75rem',
  textDecoration: 'none',
  '&.active': {
    // TODO Согласование дизайна
    color: theme.palette.aurora.main,
    position: 'relative',
  },
}));
